import { DefaultButton, Dialog, DialogFooter, MessageBar, MessageBarType, PrimaryButton, Stack, TextField } from '@fluentui/react';
import { ICommentInfo } from './CompareContext.helpers';

interface IAddCommentDialogProps {
    commentInfo: ICommentInfo | null;
    onChangeComment: (comment: string) => void;
    onAdd: () => void;
    onCancel: () => void;
}

const AddCommentDialog: React.FC<IAddCommentDialogProps> = (props) => {
    if (!props.commentInfo) {
        return null;
    }

    const title = `Add comment: ${props.commentInfo?.label ?? '?'}`;

    return (
        <Dialog
            minWidth={650}
            hidden={false}
            onDismiss={props.onCancel}
            dialogContentProps={{ title }}
        >
            <Stack tokens={{ childrenGap: 10 }}>
                {!props.commentInfo.onTarget && (
                    <MessageBar messageBarType={MessageBarType.warning}>
                        This field does not exist on the snapshot that is under review (target).
                        <br />
                        The comment will be added how ever it may not be visible for the target snapshot fields.
                    </MessageBar>
                )}
                <TextField
                    label="Comment"
                    multiline
                    autoAdjustHeight
                    defaultValue={props.commentInfo?.comment?.comment}
                    onBlur={(event) => props.onChangeComment(event.target?.value?.trim() ?? "")}
                />
            </Stack>

            <DialogFooter>
                <PrimaryButton
                    text="Add"
                    onClick={props.onAdd}
                />

                <DefaultButton
                    text="Cancel"
                    onClick={props.onCancel}
                />
            </DialogFooter>
        </Dialog>
    );
};

export default AddCommentDialog;
